import { info_tab, preview_tab } from '../../../../../../views/contract/template';

export default {
  title: 'Contractsjabloon',
  tabs: {
    [info_tab]: 'Info',
    [preview_tab]: 'Voorbeeld',
  },
  sections: {
    subscription: 'Abonnement',
    setup_cost: 'Installatiekosten',
    preview: 'Voorbeeld',
  },
  form: {
    has_trial: {
      label: 'Proefdagen toevoegen',
    },
    trial_days: {
      label: 'Gratis proefdagen',
      placeholder: '7',
      validation: {
        required: 'Proefdagen is verplicht',
        min: '{{value}} is de minimumwaarde voor proefdagen',
      },
    },
  },
  buttons: {
    apply: 'Wijzigingen toepassen',
    download: 'Downloaden',
    apply_changes: 'Wijzigingen toepassen',
  },
  files: {
    contract: '{{provider}}-contract-template-{{company}}.pdf',
  },
  toasts: {
    failed_to_load_data: 'Voorbeeld laden mislukt',
  },
};
